import { RadioGroup } from "@headlessui/react";
import { PaymentOption } from "./PaymentOption";
import { Dispatch, Fragment } from "react";
import { MyButton } from "../../../../UI/my-button/MyButton";
import { IconArrowRight } from "@tabler/icons";
import { Modal } from "@mantine/core";
import { useColors } from "../../../../../hooks/colors/useColors";
import { PaymentMethod, usePayment } from "./usePayment";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";

type InputProps = {
  opened: boolean;
  closeModal: () => void;
  selected: PaymentMethod;
  setSelected: Dispatch<PaymentMethod>;
  phone: string;
  setPhone: Dispatch<string>;
  submitForm: () => void;
  processing: boolean;
  amount: number;
};

const MyPhone = dynamic(
  () => import("./../../../../UI/phone/MyPhone").then((mod) => mod.MyPhone),
  {
    ssr: false,
  }
);

export function PaymentForm(props: InputProps) {
  const {
    opened,
    closeModal,
    selected,
    setSelected,
    phone,
    setPhone,
    submitForm,
    processing,
    amount,
  } = props;
  const { colors } = useColors();
  const { i18n } = useTranslation("common");
  const { paymentOptions } = usePayment();
  return (
    <Modal
      opened={opened}
      onClose={closeModal}
      centered
      className="!p-0 "
      style={{
        modal: {
          padding: 0,
          backgroundColor: colors.primary,
        },
      }}
    >
      <div className="w-full overflow-y-auto flex flex-col justify-center items-center p-6">
        <div className="mx-auto lg:max-w-md w-full">
          <RadioGroup value={selected} onChange={setSelected}>
            <RadioGroup.Label className="sr-only">
              {i18n.t("payment-method")}
            </RadioGroup.Label>
            <div className="space-y-4">
              {paymentOptions.map((method) => (
                <PaymentOption
                  method={method}
                  key={method.name}
                  checked={method.name === selected.name}
                />
              ))}
            </div>
          </RadioGroup>
          <Fragment>
            {selected.name === "MB WAY" && (
              <div
                className="my-6 w-full"
                style={{ background: colors.background }}
              >
                {<MyPhone setPhone={setPhone} phone={phone} hideIcon />}
              </div>
            )}

            <div className="my-6 text-center">
              <span className="text-3xl font-bold !text-white">{`${i18n.t(
                "payment.total"
              )}: `}</span>
              <span className="font-bold text-3xl !text-white">{`€${amount.toFixed(
                2
              )}`}</span>
            </div>
            <MyButton
              fullWidth
              loading={processing}
              disabled={processing}
              onClick={() => submitForm()}
              icon={<IconArrowRight />}
              title={i18n.t("payment.continue")}
              color={colors.primary}
              textColor={colors.white}
            />
          </Fragment>
        </div>
      </div>
    </Modal>
  );
}
